<div class="fud">

  <mat-dialog-content class="fud__content">

    <div class="fud__alert-banner">
      <mat-icon class="fud__alert-icon">warning</mat-icon>
      <h2 class="fud__title">Important Software Update!</h2>
      <button class="fud__close" (click)="close()" type="button">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <p class="fud__intro">
      You have one or more Risycor(s) in your overview that are no longer up to date.<br>
      To comply with new security requirements, your Risycor CXI(s) must be updated to at least
      <strong>firmware version 2.066</strong>.<br>
      Your Risycor will continue to measure and log data. Only the cloud connection will be
      disconnected if the update is not performed in time.<br>
      <strong>Please complete the update before 20th of June 2026.</strong>
    </p>

    <div class="fud__section fud__section--online">
      <h3 class="fud__section-title">
        <mat-icon>wifi</mat-icon> Is your Risycor online?
      </h3>
      <p>
        The update will be installed automatically if your network security settings are configured correctly:
      </p>
      <a href="https://www.resus.eu/sites/default/files/inline-files/cxi_it_en_v1_00.pdf"
         target="_blank" rel="noopener" class="fud__link">
        https://www.resus.eu/sites/default/files/inline-files/cxi_it_en_v1_00.pdf
      </a>
      <h4 class="fud__subsection-title">How to check if the update succeeded?</h4>
      <p>
        In the Resus Cloud Dashboard, go to <strong>"Manage risy-monitors"</strong> and verify
        that the status shows <strong>"Software up to date"</strong>.
      </p>
    </div>

    <div class="fud__section fud__section--offline">
      <h3 class="fud__section-title">
        <mat-icon>wifi_off</mat-icon> Is your Risycor offline?
      </h3>
      <p><strong>Option 1:</strong> Connect the Risycor to the internet for at least 10 minutes
        before 20th of June 2026. The Risycor does not need to be added to the Resus Cloud
        Dashboard for this update. The update will then be performed automatically. Once the
        update is successful, you will hear the Risycor restart. If you are unsure whether the
        update was successful, you can send us the serial number of your Risycor, and we can
        check this for you.</p>
      <p><strong>Option 2:</strong> Update the Risycor via USB cable using the Resus PC Dashboard.</p>
      <a href="https://www.resus.eu/sites/default/files/inline-files/TT53_How%20do%20I%20update%20a%20Risycor%20via%20the%20Resus%20PC%20Dashboard%20.pdf"
         target="_blank" rel="noopener" class="fud__link">
        Tips &amp; Tricks: How do I update a Risycor via the Resus PC Dashboard?
      </a>
      <h4 class="fud__subsection-title">How to check if the update succeeded?</h4>
      <p>
        In the Resus PC Dashboard, verify that:<br>
        Installed version ≥ <strong>2.066</strong>
      </p>
    </div>

    <div class="fud__important">
      <mat-icon class="fud__important-icon">error_outline</mat-icon>
      <div>
        <strong>Important:</strong>
        <p>Risycors that are not updated in time will no longer be able to connect to the cloud
          until they have been manually updated via the Resus PC Dashboard.</p>
      </div>
    </div>

    <div class="fud__contact">
      <p>Please contact Resus if further support is required:</p>
      <p>
        <a href="mailto:info@resus.eu" class="fud__link">info@resus.eu</a><br>
        +32 3 640 33 91
      </p>
    </div>

  </mat-dialog-content>

  <mat-dialog-actions class="fud__footer">
    <mat-checkbox [(ngModel)]="dontShowAgain" color="primary">
      Don't show this message again
    </mat-checkbox>
    <button mat-raised-button color="primary" (click)="close()">Close</button>
  </mat-dialog-actions>

</div>
